module.exports = __webpack_public_path__ + "img/bg11.0d6821bb.jpg";